import { render, staticRenderFns } from "./MultiselectDropdownItems.vue?vue&type=template&id=dc5d0d84&scoped=true&"
import script from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
export * from "./MultiselectDropdownItems.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDropdownItems.vue?vue&type=style&index=0&id=dc5d0d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d0d84",
  null
  
)

export default component.exports